import links from '@/constants/links';

export const guest = [
    {
        id: 1,
        imageSrc: 'https://gm.goz.fun/wp-content/uploads/2023/03/ads1.png',
        title: 'components.quickAds.list.0.title',
        subtitle: 'components.quickAds.list.0.subtitle',
        link: links.routes.about,
    },
    {
        id: 2,
        imageSrc: 'https://gm.goz.fun/wp-content/uploads/2023/03/ads2.png',
        title: 'components.quickAds.list.1.title',
        subtitle: 'components.quickAds.list.1.subtitle',
        link: links.general.registerGiftLink,
    },
    {
        id: 3,
        imageSrc: 'https://gm.goz.fun/wp-content/uploads/2023/03/ads3.png',
        title: 'components.quickAds.list.2.title',
        subtitle: 'components.quickAds.list.2.subtitle',
        link: links.communities.directDonate,
    },
    {
        id: 4,
        imageSrc: 'https://gm.goz.fun/wp-content/uploads/2023/03/ads4.png',
        title: 'components.quickAds.list.3.title',
        subtitle: 'components.quickAds.list.3.subtitle',
        link: links.communities.directDonate,
    },
];

export const logged = [
    ...guest.map((ad) => {
        if (ad.link === links.communities.directDonate) {
            return {
                ...ad,
                link: links.routes.checkout.replace("/:provider?", "").replace("/:id?", ""),
            }
        }

        return ad;
    }),
]

export default {
    guest,
    logged,
}
